import { FileCheck2Icon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { PermitAction } from './types'

export interface PermitActionRowProps extends ActionRowBaseProps {
  action: PermitAction
}

export function PermitActionRow({ action, ...props }: PermitActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={FileCheck2Icon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.token]} />
        Permit {action.token.symbol}
      </ActionRow.Title>

      <ActionRow.Amount token={action.token} amount={action.value} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Permit</ActionRow.Trigger>
    </ActionRow>
  )
}
